import baseURL from "@/utils/config";
import request from "@/plugins/axios";
export function getUser(data, langEnv = 2) {
  return request({
    url: `${baseURL.api}/authapi/user/userinfo2`,
    method: "post",
    data
  });
}
//地址
export function getAddress(data, langEnv = 2) {
  return request({
    url: `${baseURL.api}/api/getAddress`,
    method: "post",
    data
  });
}
//邮箱校验
export function getvalidateEmail(data, langEnv = 2) {
  return request({
    url: `${baseURL.api}/api/validateEmail`,
    method: "post",
    data
  });
}
export function validatePhone(data, langEnv = 2) {
  return request({
    url: `${baseURL.api}/api/validatePhone`,
    method: "post",
    data
  });
}
// 发送短信验证码
export function getCaptchaNew(data) {
  return request({
    url: baseURL.api + "/api/getCaptchaNew",
    method: "post",
    data
  });
}
//注册提交
export function registerNewLogin(data) {
  return request({
    url: baseURL.api + "/api/registerNewLogin",
    method: "post",
    data
  });
}
//提交认证
export function getRegisterNew(data) {
  return request({
    url: baseURL.api + "/api/registerNew",
    method: "post",
    data
  });
}
// 校验验证码
export function validatePhoneCaptcha(data) {
  return request({
    url: baseURL.api + "/api/validatePhoneCaptcha",
    method: "post",
    data
  });
}
// 登录
export function loginByCaptcha(data) {
  return request({
    url: baseURL.api + "/api/login-by-captcha",
    method: "post",
    data,
  });
}
// 重置密码
export function forgetPwdUpdatePwd(data) {
  return request({
    url: baseURL.api + "/api/forgetPwd_UpdatePwd",
    method: "post",
    data
  });
}
// 修改密码
export function updatePassword(data) {
  return request({
    url: baseURL.api + "/authapi/user/updatePassword",
    method: "post",
    data
  });
}
//获取地址列表
export function getAddressList() {
  return request({
    url: baseURL.api + "/authapi/user/searchDeliveryAddress",
    method: "post"
  });
}
//修改默认地址
export function getEditDefaultAddress(data) {
  return request({
    url: baseURL.api + "/authapi/user/defaultDeliveryAddress",
    method: "post",
    data
  });
}
//修改配送地址
export function getEditDistributionAddress(data) {
  return request({
    url: baseURL.api + "/authapi/order/changeAddr",
    method: "post",
    data
  });
}
//新增收货地址
export function getAddedShippingAddress(data) {
  return request({
    url: baseURL.api + "/authapi/user/addDeliveryAddress",
    method: "post",
    data
  });
}
//删除收货地址
export function getDelShippingAddress(data) {
  return request({
    url: baseURL.api + "/authapi/user/deleteDeliveryAddress",
    method: "post",
    data
  });
}
//地区手机编码
export function getPhoneAreaCode(data) {
  return request({
    url: baseURL.api + "/api/getAreaCode",
    method: "post",
    data
  });
}
// /authapi/user/updateDeliveryAddress
export function getEditPhoneAreaCode(data) {
  return request({
    url: baseURL.api + "/authapi/user/updateDeliveryAddress",
    method: "post",
    data
  });
}
// /authapi/order/createOrder2
export function getCreateOrder2(data) {
  return request({
    url: baseURL.api + "/authapi/order/createOrder2",
    method: "post",
    data
  });
}
// 轮询订单状态
export function pollOrderStatus(data) {
  return request({
    url: baseURL.api + "/authapi/order/pollOrderStatus",
    method: "post",
    data
  });
}

// 获取支付订单
export function getPayOrder(data) {
  return request({
    url: baseURL.api + "/authapi/pay/getPayOrder",
    method: "post",
    data
  });
}
// 获取订单详情
export function getOrderDetails(data) {
  return request({
    url: baseURL.api + "/authapi/order/getOrderDetails",
    method: "post",
    data
  });
}
// 获取订单详情
export function getSubmitPayOrder2(data) {
  return request({
    url: baseURL.api + "/authapi/pay/payOrder2",
    method: "post",
    data
  });
}
// 轮询支付结果
export function pollOrderStatusByPay(data) {
  return request({
    url: baseURL.api + "/authapi/order/pollOrderStatusByPay",
    method: "post",
    data
  });
}
//Stripe支付获取key
export function getStripeKey() {
  return request({
    url: baseURL.api + "/authapi/pay/getStripeKey",
    method: "post"
  });
}
// 关闭订单
export function closeOrder(data) {
  return request({
    url: baseURL.api + "/authapi/order/closeOrder",
    method: "post",
    data
  });
}
//获取订单列表
export function getOrderList(data) {
  return request({
    url: baseURL.api + "/authapi/order/getOrders2",
    method: "post",
    data
  });
} 
//获取订单列表
export function getConfig(data) {
  return request({
    url: baseURL.api + "/api/config",
    method: "post",
    data
  });
}
//获取openid
export function getOpenId(data) {
  return request({
    url: baseURL.api + "/api/wxOauthCallback",
    method: "post",
    data
  });
}
//获取wxOauth
export function getWxOauth(data) {
  return request({
    url: baseURL.api + "/api/wxOauth",
    method: "post",
    data
  });
}
//获取openidcourse/pay
// export function getWxpayOrderByKey(data) {
//   return request({
//     url: baseURL.api + "/api/payOrderByKey",
//     method: "post",
//     data
//   });
// }

//获取邀请码
export function getMyQrCode(data) {
  return request({
    url: baseURL.api + "/authapi/user/myQrCode",
    method: "post",
    data
  });
}
//获取邀请码海报
export function getMyQrCodePlacard(data) {
  return request({
    url: baseURL.api + "/authapi/user/myCode",
    method: "post",
    data
  });
}
//获取已邀请列表
export function getMyInviteList(data) {
  return request({
    url: baseURL.api + "/authapi/user/searchInvitationUser",
    method: "post",
    data
  });
} 
// 支付校验验证码
export function payvValidatePhoneCaptcha(data) {
  return request({
    url: baseURL.api + "/authapi/pay/validatePhoneCaptcha",
    method: "post",
    data
  });
}
// 更新手机号
export function payUpdatePhone(data) {
  return request({
    url: baseURL.api + "/authapi/user/updatePhone",
    method: "post",
    data
  });
}
// 更新支付密码
export function setPayPwd(data) {
  return request({
    url: baseURL.api + "/authapi/pay/setPayPwd",
    method: "post",
    data
  });
}
// 上传头像
export function updateUser(data) {
  return request({
    url: baseURL.api + "/authapi/user/updateUser",
    method: "post",
    data
  });
}
// 更新邮箱
export function updateEmail(data) {
  return request({
    url: baseURL.api + "/authapi/user/updateEmail",
    method: "post",
    data
  });
}
// 资质认证 ->注册没填认证信息的
export function registerNewAuth(data) {
  return request({
    url: baseURL.api + "/api/registerNewAuth",
    method: "post",
    data,
  });
}
// 资质认证 ->认证被拒绝 重新提交资质认证的
export function userAuthNew(data) {
  return request({
    url: baseURL.api + "/authapi/user/userAuthNew",
    method: "post",
    data,
  });
}
// 修改用户地址
export function updateUserAddress(data) {
  return request({
    url: baseURL.api + "/authapi/user/updateUserAddress",
    method: "post",
    data,
  });
}
// 获取收藏
export function getUserGoodsCollection(data) {
  return request({
    url: baseURL.api + "/authapi/user/getUserGoodsCollection",
    method: "post",
    data,
  });
}
// 删除/添加收藏
export function selCollectProduct(data) {
  return request({
    url: baseURL.api + "/authapi/user/collectProduct",
    method: "post",
    data,
  });
}
// 
//  批量添加收藏
export function batchCollectProduct(data) {
  return request({
    url: baseURL.api + "/authapi/user/collectProducts2 ",
    method: "post",
    data,
  });
}
// 获取历史记录
export function getBrowsingHistory(data) {
  return request({
    url: baseURL.api + "/api/product/getBrowsingHistory",
    method: "post",
    data,
  });
}
// 删除历史记录
export function deleteBrowsingHistory(data) {
  return request({
    url: baseURL.api + "/api/product/deleteBrowsingHistory",
    method: "post",
    data,
  });
}
// 售后订单的列表
export function getAfterSaleRecords(data) {
  return request({
    url: baseURL.api + "/authapi/afterSale/afterSaleRecords",
    method: "post",
    data,
  });
}
// 获取售后详情
export function getAfterSaleDetail(data) {
  return request({
    url: baseURL.api + "/authapi/afterSale/afterSaleDetail",
    method: "post",
    data,
  });
}
// 获取查询退货商品列表
export function getChildOrders(data) {
  return request({
    url: baseURL.api + "/authapi/afterSale/childOrders",
    method: "post",
    data,
  });
}
// 获取选择退货商品
export function getOrderProductList(data) {
  return request({
    url: baseURL.api + "/authapi/afterSale/orderProductList",
    method: "post",
    data,
  });
}
